import { Box, Flex, Group, Modal, Stack, Text, useMantineTheme } from '@mantine/core';

import { useDisclosure } from '@mantine/hooks';

import RecentProposals from './RecentProposals/RecentProposals';
import classes from './Dashboard.module.css';
import { ResourceAssistantChat } from '../../components';
import { defaultModalProps } from '../../utils/mantineUtils';
import { FastDraftSetup } from '../../components/Modals';
import OpportunityEvaluations from './OpportunityEvaluations/OpportunityEvaluations';

const Dashboard: React.FC = () => {
  const { colors } = useMantineTheme();
  const [fastDraftSetupOpened, fastDraftSetupHandlers] = useDisclosure(false);

  return (<>
    <Modal {...defaultModalProps} opened={fastDraftSetupOpened} size={1000}>
      <FastDraftSetup
        onClose={fastDraftSetupHandlers.close}
      />
    </Modal>
    <Flex bg={colors.lightPurple[0]} h='100%'>
      <Group gap={16} mx={16} mb={16} w='100%' flex={1}>
        <Stack w='75%' gap={16} h='100%'>
          <Box h={177} p={16} className={classes.containerRoot}>
            <RecentProposals onClickFastDraft={fastDraftSetupHandlers.open} />
          </Box>
          <Flex p={16} flex={1} className={classes.containerRoot}>
            <OpportunityEvaluations />
          </Flex>
        </Stack>
        <Flex flex={1} h='100%' w='100%'>
          <Stack gap={0} className={classes.containerRoot} w='100%'>
            <Text m={16}>
              Resource Assistant
            </Text>
            <ResourceAssistantChat
              style={{ flex: 1 }}
              classNames={{
                root: classes.resourceAssistantMessageRoot,
                bottomContainer: classes.resourceAssistantBottomContainer
              }}
            />
          </Stack>
        </Flex>
      </Group >
    </Flex >
  </>
  );
};
export default Dashboard;
